import {css} from '../theme/css'
import {breakpoints} from '../theme/theme'

export const classes = {
  smDown: css`
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  mdUp: css`
    ${breakpoints.up('md')} {
      display: none;
    }
  `,
}
